module.exports = __webpack_public_path__ + "static/media/user.ec543442.png";